import PointService from '@/common/api/point'
import {
  GET_BANK_ACCOUNT,
  GET_PRODUCT_LIST,
  GET_PRODUCT,
  GET_PRICE_LIST,
  GET_ORDER,
  GET_BITCASH_PREPARE,
  GET_NETRIDECASH_PREPARE,
  GET_ORDER_COMPLETE
} from './actions'
import {
} from './mutations'

const state = {
}

const getters = {
}

const actions = {
  [GET_BANK_ACCOUNT] (context, params = {}) {
    return new Promise((resolve, reject) => {
      PointService.getBankAccount(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_PRODUCT_LIST] (context, params = {}) {
    return new Promise((resolve, reject) => {
      PointService.getProductList(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_PRODUCT] (context, { paymentWay, params = {} }) {
    return new Promise((resolve, reject) => {
      PointService.getProduct(paymentWay, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_PRICE_LIST] (context, { paymentWay, params = {} }) {
    return new Promise((resolve, reject) => {
      PointService.getPriceList(paymentWay, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_ORDER] (context, params = {}) {
    return new Promise((resolve, reject) => {
      PointService.getOrder(params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_BITCASH_PREPARE] (context, { id, params = {} }) {
    return new Promise((resolve, reject) => {
      PointService.getBitcashPrepare(id, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_NETRIDECASH_PREPARE] (context, { id, params = {} }) {
    return new Promise((resolve, reject) => {
      PointService.getNetridecashPrepare(id, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  [GET_ORDER_COMPLETE] (context, { id, paymentWay, params = {} }) {
    return new Promise((resolve, reject) => {
      PointService.getOrderComplete(id, paymentWay, params)
        .then(({ data }) => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}
